<template>
  <page-outline :title="store == 0 ? $t('common.security.add_p12', {itemLabel: 'truststore'}): $t('common.security.add_p12', {itemLabel: 'keystore'})">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <form-accordion :title="$t('common.security.p12')" :isTitleUpperCase="false">
          <div class="form-group">
            <input type="file" @change="onFileChange" accept=".p12" ref="fileInputP12" />
          </div>
        </form-accordion>
        <hr  class="mx-auto mb-4" v-if="certificateInfo" />
        <form-accordion v-if="certificateInfo" :title="$t('common.security.keystore')" :isTitleUpperCase="false">
          <b-row class="d-flex justify-content-start form-group">
            <b-col sm="2" class="form-group">
              <b-form-checkbox v-model="form.keystore.state"
                :value="1"
                :unchecked-value="0">
                <span class="text-break">{{ form.keystore.nameDisplay }}</span>
              </b-form-checkbox>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-write-group-label-input v-model="form.keystore.name" isMandatory
                :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-write-group-label-input v-model="form.keystore.password"
                :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
              </form-write-group-label-input>
            </b-col>
            <!--b-col sm="2" class="form-group">
              <div>
                <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
                <b-form-select v-model="form.keystore.pod" :options="podList" style="font-size:small;"></b-form-select>
              </div>
            </b-col-->
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="form.keystore.startDate"
                :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="form.keystore.endDate"
                :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="form.keystore.deliveredBy"
                :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="form.keystore.deliveredTo"
                :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
              </form-read-group-label-input>
            </b-col>
          </b-row>
          <b-row class="mt-3 justify-content-end form-group">
            <b-col cols="4" lg="2" xl="2" v-if="form.keystore.state">
              <b-button variant="primary"
                @click="createKeystore()">
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.security.add_keystore') }}</span>
              </b-button>
            </b-col>
            <b-col cols="4" lg="2" xl="2" v-else>
              <b-button variant="primary" disabled>
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.security.add_keystore') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </form-accordion>
        <hr  class="mx-auto mb-4" v-if="certificateInfo" />
        <form-accordion v-if="certificateInfo" :title="$t('common.security.truststore')" :isTitleUpperCase="false">
          <b-row v-for="(certifcat, index) in form.truststore" class="d-flex align-items-center form-group" :key="index">
            <b-col sm="2" class="form-group mb-5">
              <b-form-checkbox v-model="certifcat.state"
                :value="1"
                :unchecked-value="0">
                <span class="text-break">{{ certifcat.nameDisplay }}</span>
              </b-form-checkbox>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-write-group-label-input v-model="certifcat.name" isMandatory
                :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
              </form-write-group-label-input>
            </b-col>
            <!--b-col sm="2" class="form-group">
              <div>
                <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
                <b-form-select v-model="form.truststorePod" :options="podList" style="font-size:small;"></b-form-select>
              </div>
            </b-col-->
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="certifcat.startDate"
                :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="certifcat.endDate"
                :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="certifcat.deliveredBy"
                                           :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
              <form-read-group-label-input :inputValue="certifcat.deliveredTo"
                                           :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
              </form-read-group-label-input>
            </b-col>
          </b-row>
          <b-row class="mt-3 justify-content-end">
            <b-col cols="6" lg="3" xl="2" v-if="canSaveTrustStore">
              <b-button variant="primary"
                @click="showModal('create')">
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.security.link_truststore') }}</span>
              </b-button>
            </b-col>
            <b-col cols="6" lg="3" xl="2" v-else>
              <b-button variant="primary" disabled>
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.security.link_truststore') }}</span>
              </b-button>
            </b-col>
            <b-col cols="6" lg="3" xl="2" v-if="canSaveTrustStore">
              <b-button class="ml-2" variant="primary"
                @click="showModal('link')">
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.security.create_truststore') }}</span>
              </b-button>
            </b-col>
            <b-col cols="6" lg="3" xl="2" v-else>
              <b-button variant="primary" class="ml-2" disabled>
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.security.create_truststore') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </form-accordion>
        <security-pop-up v-if="showModalElement" @close="close" @savepopup="createTruststore" :caList="caListPopUp" ></security-pop-up>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import forge from 'node-forge';
import SecurityPopUp from "@/popups/security/SecurityPopUp.vue";

export default {
  name: 'SecurityForm',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'security-pop-up': SecurityPopUp
  },
  props: ['id', 'store'],
  data () {
    return {
      form: {
        keystore: {
          state: 0,
          privateKey: '',
          certificate: '',
          startDate: '',
          endDate: '',
          deliveredBy: '',
          deliveredTo: '',
          name: '',
          nameDisplay: '',
          pod: '',
          password:'',
        },
        truststore: [],
        truststorePod: '',
        name: '',
        id: '',

      },
      certificateInfo: null,
      active: '0',
      filteredNorms: [],
      hrtpNorm: false,
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      profiles: [],
      srtpNorm: false,
      showModalElement: false,
      id_rights_profile: '',
      caList: [],
      caListPopUp: [],
      podList: [],
      canSaveTrustStore: false,
      returnUrl: '/security/0'
    }
  },
  created () {
    this.profiles = this.$engine.company.profiles.sort((a, b) => {
      return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
    })
    this.$engine.security.ca.fetch().then(resp => {
      if (resp.data.ca.length > 0) {
        this.caList.push({text: this.$i18n.t('common.security.select_an_option'), value: ''})
        resp.data.ca.forEach(element => {
          this.caList.push({text: element.name, value: element.id})
        })
      }

    })
    .catch(error => {
      errorMessageAlert(error, that)
    })
    /*this.$engine.routing.pod.fetch()
        .then(resp => {
          if (resp.data.Pods.length != 0){
            this.podList.push({text: this.$i18n.t('common.security.select_an_option'), value: ""})
            resp.data.Pods.forEach(element => {
              this.podList.push({text: element.name, value: element.name})
            })
          }

        })*/
    this.filteredNorms = _.cloneDeep(this.profiles.filter(profile => {
      return profile.libelle.includes('Norm_')
    }))
    let that = this
    this.filteredNorms.forEach(profile => {
      profile.active = 0
      profile.libelle = that.$i18n.t('requestToPay.norms.' + profile.libelle.split('_')[1])
    })
    this.filteredNorms.sort(function (a, b) {
      return a.libelle < b.libelle ? -1 : 1
    })
  },
  watch: {
    form: {
      handler() {
        this.truststoreSelected()
      },
      deep: true,
    },
  },
  methods: {
    truststoreSelected(){
      let flag = 0
      this.form.truststore.forEach(element => {
        if (element.state == 1){
          flag = 1
        }
      })
      if(flag){
        this.canSaveTrustStore = true
      }
      else{
        this.canSaveTrustStore = false
      }
    },
    close(){
      this.showModalElement = false
    },
    isCertificateAuthority(cert) {
      const basicConstraints = cert.getExtension('basicConstraints');
      return basicConstraints && basicConstraints.cA;
    },
    async onFileChange(event) {
      this.resetForm()
      let that = this
      const file = event.target.files[0];
      if (file) {
        const base64String = await this.readFileAsBase64(file)
        const password = prompt('Entrez le mot de passe du fichier P12 (laissez vide si aucun mot de passe):') || ''


        const p12b64 = base64String.split(',')[1]
        try {
          // Charger et décoder le fichier P12 avec node-forge
          let p12Der = forge.util.decode64(p12b64);
          let p12Asn1 = forge.asn1.fromDer(p12Der);

          var p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, false, password)

          // Récupérer les certificats et les clés
          const keyStore = [];
          const keyStoreSafeBag = [];
          const trustStore = [];
          const trustStoreSafeBag = [];
          that.form.truststore = []
          that.form.keystore = {
            state: 0,
            privateKey: '',
            certificate: '',
            startDate: '',
            endDate: '',
            name: '',
            nameDisplay: '',
            pod: '',
            password: '',
          }

          p12.safeContents.forEach(function (safeContent) {
            safeContent.safeBags.forEach(function (safeBag) {
              if (safeBag.type === forge.pki.oids.pkcs8ShroudedKeyBag) {
                const privateKey = forge.pki.privateKeyToPem(safeBag.key);
                keyStore.push(privateKey);
                keyStoreSafeBag.push(safeBag);
                that.form.keystore.privateKey = privateKey
                if (safeBag.attributes.friendlyName){
                  that.form.keystore.nameDisplay = safeBag.attributes.friendlyName[0]
                }
              } else if (safeBag.cert) {
                const certPem = forge.pki.certificateToPem(safeBag.cert);

                // Si le certificat est un CA, on le place dans le truststore
                if (that.isCertificateAuthority(safeBag.cert)) {
                  trustStore.push(certPem);
                  trustStoreSafeBag.push(safeBag)
                  let element = {
                    state: 0,
                    certificate: certPem,
                    startDate: safeBag.cert.validity != undefined ? safeBag.cert.validity.notBefore.toLocaleString().toString() : '',
                    endDate: safeBag.cert.validity != undefined ? safeBag.cert.validity.notAfter.toLocaleString().toString() : '',
                    deliveredBy: '',
                    deliveredTo: '',
                    name: '',
                    pod: '',
                    nameDisplay: safeBag.attributes.friendlyName != undefined ? safeBag.attributes.friendlyName[0].toString() : ''
                  }
                  safeBag.cert.issuer.attributes.forEach(e => {
                    if (e.name == 'commonName'){
                      element.deliveredBy = e.value
                    }
                  })
                  safeBag.cert.subject.attributes.forEach(e => {
                    if (e.name == 'commonName'){
                      element.deliveredTo = e.value
                    }
                  })
                  that.form.truststore.push(element)
                } else {
                  keyStore.push(certPem); // Certificat associé à la clé privée
                  keyStoreSafeBag.push(safeBag); // Certificat associé à la clé privée
                  that.form.keystore.certificate = certPem
                  that.form.keystore.startDate = safeBag.cert.validity != undefined ? safeBag.cert.validity.notBefore.toLocaleString().toString() : ''
                  that.form.keystore.endDate = safeBag.cert.validity != undefined ? safeBag.cert.validity.notAfter.toLocaleString().toString() : ''
                }
              }
            });
          });

          let bags = p12.getBags({bagType: forge.pki.oids.certBag});
          let cert = bags[forge.pki.oids.certBag][0]
          cert.cert.issuer.attributes.forEach(element => {
            if (element.name == 'commonName'){
              this.form.keystore.deliveredBy = element.value
            }
          })
          cert.cert.subject.attributes.forEach(element => {
            if (element.name == 'commonName'){
              this.form.keystore.deliveredTo = element.value
            }
          })


          this.certificateInfo = {
            keystore: keyStore.join('\n'),
            truststore: trustStore.join('\n')
          };
        } catch (error) {
          that.$f7.alert(error, 'Error')
          this.resetFileInput()
        }
      }
    },
    resetFileInput() {
      this.$refs.fileInputP12.value = ''
    },
    resetForm(){
      this.certificateInfo = false
      this.form = {
        keystore: {
          state: 0,
              privateKey: '',
              certificate: '',
              startDate: '',
              endDate: '',
              deliveredBy: '',
              deliveredTo: '',
              name: '',
              nameDisplay: '',
              pod: '',
              password:'',
        },
        truststore: [],
            truststorePod: '',
            name: '',
            id: '',

      }
    },
    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result); // Le résultat est en Base64
        reader.onerror = reject;
        reader.readAsDataURL(file); // Lire en Base64 (Data URL)
      });
    },
    createTruststore(dataNameId){
      let that = this
      that.form.id = dataNameId.id
      that.form.name = dataNameId.name
      if (that.form.name != '' || that.form.id != ''){
        let flag = 0
        /// check formumlaire si state 1
        that.form.truststore.forEach(element => {
          if (element.state == 1){
            flag = 1
          }
        })
        if (flag == 0){
          return
        }
        let certificates = []
        flag = false
        let count = 0
        that.form.truststore.forEach(element => {
          if (element.state == 1){
            /*if (that.form.truststorePod == '') {
              that.$f7.alert(that.$i18n.t('common.security.missing_truststore_pod'), 'Error')
            }*/
            if (element.name == '') {
              that.$f7.alert(that.$i18n.t('common.security.missing_truststore_name'), 'Error')
            }
            if(/*element.pod != '' ||*/ element.name){
              let form = {
                idPod: that.form.truststorePod,
                name: element.name,
                certificate: element.certificate,
                startDate: element.startDate,
                endDate: element.endDate,
                deliveredBy: element.deliveredBy,
                deliveredTo: element.deliveredTo,
                commonName: element.nameDisplay,
                type: 'SSL'
              }

              if (that.formHasError()) {
                return
              }

              that.$engine.security.certificates.create(form)
              .then(resp => {

                count++
                certificates.push(resp.data.idCertificat)

                  let form = {
                    certificates: certificates,
                    idPod: that.form.truststorePod
                  }
                  if (that.form.name != ''){
                    form.name = that.form.name
                  } else{
                    form.idCA = that.form.id
                  }

                  if (that.formHasError()) {
                    return
                  }

                if (count == that.form.truststore.filter(element => element.state == 1).length){
                  flag = true
                }
                if (flag){
                  that.$engine.security.ca.create(form)
                  .then(resp => {
                    that.$f7.alert(that.$i18n.t('common.security.added_certificate_truststore'), that.$i18n.t('common.security.adding_certificate_truststore'))
                  })
                  .catch(e => {
                    errorMessageAlert(e, that)
                    that.okMessageBox(that.$t('common.security.add_certificate_truststore_error'))
                  })
                }
              })
              .catch(e => {
                errorMessageAlert(e, that)
                that.okMessageBox(that.$t('common.security.cert_addition_error'))
              })
            }
          }
        })
      }
    },
    showModal(method){
      if (method == 'create'){
        this.caListPopUp = this.caList
      }
      else if (method == 'link'){
        this.caListPopUp = null
      }
      this.showModalElement = true
    },
    createKeystore(){
      let that = this
      if (this.form.keystore.state == 1){
        /*if (this.form.keystore.password == '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_password'), 'Error')
        }*/
        /*else if (this.form.keystore.pod == '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_pod'), 'Error')
        }*/
        if (this.form.keystore.name == '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_name'), 'Error')
        }
        if(this.form.keystore.password != '' || this.form.keystore.pod != '' || this.form.keystore.name != ''){
          let form = {
            name: this.form.keystore.name,
            privateKey: this.form.keystore.privateKey,
            password: this.form.keystore.password,
            passwordVerif: this.form.keystore.password,
            idPod: this.form.keystore.pod,
            "type": "SSL"
          }
          let privateKeyId = ''
          let CertificateId = ''

          let that = this

          if (this.formHasError()) {
            return
          }

          this.$engine.security.private_keys.create(form)
          .then(resp => {
            privateKeyId = resp.data.idPrivateKey


            form = {
              idPod: this.form.keystore.pod,
              name: this.form.keystore.name,
              certificate: this.form.keystore.certificate,
              startDate: this.form.keystore.startDate,
              endDate: this.form.keystore.endDate,
              deliveredBy: this.form.keystore.deliveredBy,
              deliveredTo: this.form.keystore.deliveredTo,
              commonName: this.form.keystore.nameDisplay,
              type: 'SSL',
            }

            let that = this

            if (this.formHasError()) {
              return
            }

            this.$engine.security.certificates.create(form)
            .then(resp => {
              CertificateId = resp.data.idCertificat

              form = {
                privateKeyId,CertificateId,name: this.form.keystore.name
              }
              this.$engine.security.keystore.create(form)
              .then(resp => {
                that.$f7.alert(that.$i18n.t('common.security.created_keystore'), that.$i18n.t('common.security.creation_keystore'))
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            })
            .catch(e => {
              errorMessageAlert(e, that)
              that.okMessageBox(that.$t('common.security.cert_addition_error'))
            })

          })
          .catch(e => {
            errorMessageAlert(e, that)
            that.okMessageBox(this.$t('common.security.priv_key_addition_error'))
          })
        }
      }
    },
    createCA (form) {
      let that = this
      if (this.formHasError()) {
        return
      }
      this.$engine.security.ca.create(form)
      .then(resp => {
        that.$f7.alert(that.$i18n.t('common.security.added_certificate_truststore'), that.$i18n.t('common.security.adding_certificate_truststore'))
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.add_certificate_truststore_error'))
      })
    },
    createPrivateKey (form) {
      let that = this

      if (this.formHasError()) {
        return
      }

      this.$engine.security.private_keys.create(form)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.priv_key_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(this.$t('common.security.priv_key_addition_error'))
      })
    },
    createCertificate(form){
      let that = this

      if (this.formHasError()) {
        return
      }

      this.$engine.security.certificates.create(form)
      .then(resp => {
        return resp.data.idCertificat
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.cert_addition_error'))
      })
    },
    formHasError() {
      // let that = this
      // let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      // if (this.login === undefined || this.login === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_login'))
      //   return true
      // }
      // if (this.name === undefined || this.name === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_name'))
      //   return true
      // }
      // if (this.password === undefined || this.password === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_password'))
      //   return true
      // }
      // if (this.password && !regexPassword.test(this.password)) {
      //   this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
      //   return true
      // }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //         || (that.srtpNorm && status.label.includes('_SRTP'))
      //         || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      // return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    }
  }
}
</script>
